import { apiRequest } from './client';
import { registerCurrencies } from './billingApi';

/** Master data (SRS #87) + country/currency configuration (SRS #86). */

export interface Currency { code: string; symbol: string; name: string }
export interface Country { code: string; name: string; currency: string; enabled?: boolean }
export interface PublicBilling { currency: string; currency_symbol: string; default_country: string | null; tax_label: string }
export interface MasterData {
  industries: string[]; organization_types: string[]; job_roles: string[]; regulation_types: string[];
  use_cases: string[]; team_sizes: string[]; company_sizes: string[];
  currencies: Currency[]; countries: Country[]; billing: PublicBilling;
}
export type ListSet = 'industries' | 'organization_types' | 'job_roles' | 'regulation_types' | 'use_cases' | 'team_sizes' | 'company_sizes';
export type SetName = ListSet | 'currencies' | 'countries' | 'billing';
export interface AdminBilling { currency: string; default_country: string | null; tax_label: string; tax_rate_percent: number | null; restrict_to_enabled_countries: boolean }
export interface AdminSets { sets: Record<SetName, { items: unknown; overridden: boolean; default: unknown }> }

const TOKEN_KEY = 'policyora_token';
const auth = (extra: RequestInit = {}): RequestInit => {
  const token = localStorage.getItem(TOKEN_KEY);
  return { ...extra, headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(extra.headers || {}) } };
};

let cache: { at: number; data: MasterData } | null = null;
/** Public, cached for the session: the lists every form needs. */
export async function getMasterData(): Promise<MasterData> {
  if (cache && Date.now() - cache.at < 5 * 60_000) return cache.data;
  const data = await apiRequest<MasterData>('/api/v1/master-data');
  registerCurrencies(data.currencies);
  cache = { at: Date.now(), data };
  return data;
}
export const invalidateMasterData = () => { cache = null; };

export const adminGetMasterData = () => apiRequest<AdminSets>('/api/v1/admin/master-data', auth());
export const adminPutMasterData = (name: SetName, value: unknown) =>
  apiRequest<{ name: SetName; items: unknown; overridden: boolean }>(`/api/v1/admin/master-data/${name}`, auth({ method: 'PUT', body: JSON.stringify(value) }));
export const adminResetMasterData = (name: SetName) =>
  apiRequest<{ name: SetName; items: unknown; overridden: boolean }>(`/api/v1/admin/master-data/${name}`, auth({ method: 'DELETE' }));
